var imageElement = document.getElementById("header-logo");
var originalWidth = imageElement.clientWidth;
var originalHeight = imageElement.clientHeight;
var containerHeader = document.querySelector(".container--header");
var acHeaderContainer = document.querySelector(".header-container");

function resizeImage() {
	var headerPosition = document
		.querySelector(".mount-header")
		.getBoundingClientRect().top;
	var scaleFactor = headerPosition <= 0 ? 0.8 : 1;
	var newWidth = originalWidth * scaleFactor;
	var newHeight = originalHeight * scaleFactor;

	imageElement.style.width = newWidth + "px";
	imageElement.style.height = newHeight + "px";

	if (scaleFactor < 1) {
		containerHeader.style.padding = "16px";
	} else {
		containerHeader.style.padding = "";
	}
}

window.onscroll = resizeImage;
window.addEventListener("resize", resizeImage);
